/**
 * Cart Drawer Enhancements
 * Handles: upsell quick-add, discount code application & removal
 * Uses event delegation so handlers survive DOM replacement from section rendering.
 */

(function () {
  'use strict';

  /* ---------- Helper: Re-render cart drawer sections ---------- */

  function rerenderCartDrawer() {
    var cartDrawer = document.querySelector('cart-drawer');
    var sections = 'cart-drawer,cart-icon-bubble';

    return fetch(window.routes.cart_url + '?sections=' + sections)
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents({ sections: data });
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-drawer-discount',
            cartData: data
          });
        }
      });
  }

  /* ---------- Upsell Quick-Add ---------- */

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('.cde-upsells__add-btn');
    if (!btn || btn.disabled) return;

    var variantId = btn.dataset.variantId;
    if (!variantId) return;

    btn.classList.add('loading');
    btn.disabled = true;

    var cartDrawer = document.querySelector('cart-drawer');
    var sections = 'cart-drawer,cart-icon-bubble';

    fetch(window.routes.cart_add_url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId, 10), quantity: 1 }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (response) { return response.json(); })
      .then(function (data) {
        if (data.status) {
          btn.classList.remove('loading');
          btn.disabled = false;
          console.error('Cart add error:', data.description);
          return;
        }

        if (cartDrawer && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.renderContents(data);
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'cart-drawer-upsell',
            productVariantId: variantId,
            cartData: data
          });
        }
      })
      .catch(function (err) {
        console.error('Failed to add upsell item:', err);
        btn.classList.remove('loading');
        btn.disabled = false;
      });
  });

  /* ---------- Discount Code: Apply ---------- */

  document.addEventListener('click', function (event) {
    var applyBtn = event.target.closest('#CartDrawer-DiscountApply');
    if (!applyBtn) return;

    handleDiscountApply(applyBtn);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Enter' && event.target.id === 'CartDrawer-DiscountInput') {
      event.preventDefault();
      var applyBtn = document.getElementById('CartDrawer-DiscountApply');
      if (applyBtn) handleDiscountApply(applyBtn);
    }
  });

  function handleDiscountApply(applyBtn) {
    var input = document.getElementById('CartDrawer-DiscountInput');
    var messageEl = document.getElementById('CartDrawer-DiscountMessage');
    if (!input || !messageEl) return;

    var code = input.value.trim();
    if (!code) {
      showMessage(messageEl, 'Please enter a discount code.', 'error');
      return;
    }

    applyBtn.classList.add('loading');
    applyBtn.disabled = true;

    fetch('/discount/' + encodeURIComponent(code), {
      method: 'GET',
      redirect: 'follow'
    })
      .then(function () {
        input.value = '';
        showMessage(messageEl, 'Applying discount...', 'success');

        /* Re-render the cart drawer to show the discount line item */
        return rerenderCartDrawer();
      })
      .then(function () {
        /* Check if a discount is now showing in the re-rendered drawer */
        var discountEls = document.querySelectorAll('.cde-applied-discount');
        if (discountEls.length > 0) {
          hideMessage(messageEl);
        } else {
          showMessage(messageEl, 'Code "' + code + '" applied - you will see the discount at checkout.', 'success');
        }
      })
      .catch(function () {
        showMessage(messageEl, 'Something went wrong. Please try again.', 'error');
      })
      .finally(function () {
        applyBtn.classList.remove('loading');
        applyBtn.disabled = false;
      });
  }

  /* ---------- Discount Code: Remove ---------- */

  document.addEventListener('click', function (event) {
    var removeBtn = event.target.closest('.cde-applied-discount__remove');
    if (!removeBtn) return;

    removeBtn.disabled = true;

    /* Clear discount code cookie (legacy Shopify stores) */
    document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';

    /* Use Shopify cart update endpoint to clear discount from session */
    fetch(window.routes.cart_update_url || '/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({ discount: '' })
    })
      .then(function () {
        return rerenderCartDrawer();
      })
      .catch(function () {
        /* Fallback: try the URL-based clear, then re-render */
        return fetch('/discount/', { method: 'GET', redirect: 'manual' })
          .then(function () { return rerenderCartDrawer(); });
      })
      .catch(function (err) {
        console.error('Failed to remove discount:', err);
        removeBtn.disabled = false;
      });
  });

  /* ---------- Minus Button: Remove Item at Qty 1 ---------- */

  document.addEventListener('click', function (event) {
    var minusBtn = event.target.closest('quantity-input button[name="minus"]');
    if (!minusBtn) return;

    /* Only act inside the cart drawer */
    var cartDrawer = minusBtn.closest('cart-drawer');
    if (!cartDrawer) return;

    var input = minusBtn.closest('quantity-input').querySelector('.quantity__input');
    if (!input) return;

    var currentQty = parseInt(input.value, 10);
    if (currentQty !== 1) return;

    /* Quantity is 1 and they hit minus - remove the item */
    event.preventDefault();
    event.stopPropagation();

    var lineIndex = input.dataset.index;
    var cartItems = minusBtn.closest('cart-items') || minusBtn.closest('cart-drawer-items');
    if (cartItems && typeof cartItems.updateQuantity === 'function') {
      cartItems.updateQuantity(lineIndex, 0);
    }
  }, true);

  /* ---------- Message Helpers ---------- */

  function showMessage(el, text, type) {
    el.textContent = text;
    el.classList.remove('hidden', 'success', 'error');
    el.classList.add(type);
  }

  function hideMessage(el) {
    if (!el) return;
    el.textContent = '';
    el.classList.add('hidden');
    el.classList.remove('success', 'error');
  }
})();
